import React from 'react'
import * as R from 'ramda'
import { Dropdown } from 'semantic-ui-react'

import { getOptionDiscriminator } from 'libs/filter-rule-discriminator'

/** @typedef {import('shared/components/FilterGroup/container').Extra} Extra */
/**
 * @template T
 * @typedef {import('shared/components/FilterGroup').Option<T>} Option
 */
/**
 * @template T
 * @typedef {import('shared/components/FilterGroup/reducer').Rule<T>} Rule
 */
/**
 * @param {object} props
 * @param {object=} props.style
 * @param {boolean} props.open
 * @param {Option<Extra>[]} props.options
 * @param {() => void=} props.onBlur
 * @param {() => void} props.onClose
 * @param {(rule: Rule<Extra>, groupIndex?: number) => void} props.onFilterAdd
 */
export function FilterDropdown({ style, open, options, onBlur, onClose, onFilterAdd }) {
  if (!open) {
    return null
  }
  const handleAddFilter = (_, { value: [value] }) => {
    /**
     * @type {Option<Extra>}
     */
    const selectedOption = R.find((option) => {
      const optionValue = option.field + getOptionDiscriminator(option.extra)
      return value === optionValue
    }, options)

    // HACK alert!!! I don't know why using enter key to add filter will cause the other
    // input (dropdown) that has auto focus to select the first choice in the list. But
    // defer adding filter action to another frame (or event loop) work. My suspect is
    // that the enter event somehow keep going and apply to the input elements. That's
    // how I could explain why when the inputs are auto focus and open the dropdown
    // the event gets apply to the dropdown causing the first option to be selected.
    requestAnimationFrame(() => {
      onFilterAdd({
        filters: [],
        ...selectedOption,
      })
    })
  }

  const semanticUIOptions = options.map(({ field, label, icon, extra }, index) => ({
    key: index,
    className: 'flex',
    field,
    text: label,
    value: field + getOptionDiscriminator(extra),
    icon,
  }))

  return (
    <Dropdown
      searchInput={{ autoFocus: true }}
      fluid
      multiple
      placeholder="Search filters..."
      noResultsMessage="No available filters"
      search
      selection
      options={semanticUIOptions}
      style={{
        position: 'absolute',
        width: 300,
        ...style,
      }}
      onBlur={onBlur}
      onClose={onClose}
      onChange={handleAddFilter}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/FilterDropdown/index.js